import { render, staticRenderFns } from "./VgcProductModelPikcer.vue?vue&type=template&id=13286fbd&scoped=true"
import script from "./VgcProductModelPikcer.vue?vue&type=script&lang=js"
export * from "./VgcProductModelPikcer.vue?vue&type=script&lang=js"
import style0 from "./VgcProductModelPikcer.vue?vue&type=style&index=0&id=13286fbd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13286fbd",
  null
  
)

export default component.exports